
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.4277 12.2593C24.3482 12.0709 24.2192 11.9092 24.0553 11.7926C23.8914 11.676 23.6991 11.609 23.5002 11.5994H18.6175L21.6714 6.38638C21.7145 6.22325 21.7206 6.05207 21.6892 5.88612C21.6578 5.72018 21.5897 5.56395 21.4902 5.42956C21.3898 5.295 21.2605 5.18624 21.1125 5.11183C20.9646 5.03741 20.8019 4.99936 20.6373 5.00065H13.1747C12.934 4.99214 12.6976 5.06795 12.504 5.21573C12.3105 5.36351 12.1711 5.57456 12.1086 5.81449L7.55148 16.8124C7.50802 16.9785 7.50294 17.1529 7.53667 17.3214C7.5704 17.4899 7.64199 17.6479 7.74568 17.7827C7.84938 17.9175 7.98228 18.0253 8.13371 18.0974C8.28514 18.1696 8.45087 18.2041 8.61757 18.1981H12.722L10.7924 25.6107C10.7292 25.8497 10.746 26.1038 10.8403 26.3317C10.9345 26.5596 11.1005 26.748 11.3115 26.8664C11.5225 26.9847 11.7661 27.0261 12.0027 26.9839C12.2394 26.9416 12.4553 26.8182 12.6154 26.6335L24.2358 13.436C24.3741 13.2797 24.4658 13.0856 24.4999 12.8768C24.5339 12.6681 24.5088 12.4537 24.4277 12.2593ZM13.9907 21.8054L15.142 17.4063C15.1901 17.2408 15.1998 17.0659 15.1701 16.8958C15.1405 16.7258 15.0724 16.5653 14.9715 16.4275C14.87 16.2914 14.739 16.1817 14.589 16.1073C14.4391 16.0328 14.2743 15.9955 14.1079 15.9985H10.0141L13.9956 7.20022H18.5646L15.5557 12.4132C15.5122 12.5794 15.5072 12.7537 15.5409 12.9222C15.5746 13.0907 15.6462 13.2487 15.7499 13.3835C15.8536 13.5183 15.9865 13.6261 16.1379 13.6983C16.2894 13.7704 16.4551 13.8049 16.6218 13.799H21.0695L13.9907 21.8054Z","fill":"#10001F"}})])
          )
        }
      }
    